import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g fill={fill || "currentColor"} clipPath="url(#a)">
      <path d="M9.6 2.4a2.4 2.4 0 1 0 4.8 0 2.4 2.4 0 0 0-4.8 0ZM9.6 12a2.4 2.4 0 1 0 4.8 0 2.4 2.4 0 0 0-4.8 0ZM9.6 21.6a2.4 2.4 0 1 0 4.8 0 2.4 2.4 0 0 0-4.8 0Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill={fill || "currentColor"} d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
